<template>
    <section class="section-first section section-shaped overflow-hidden my-0">
        <div class="shape shape-style-1 shape-light">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="col-lg-24 mb-lg-auto">
            <div class="shadow-lg overflow-hidden transform-perspective-right">
                <b-carousel id="carousel1" controls indicators>
                    <!-- Text slides with image -->
                    <b-carousel-slide img-src="img/carousel/p1.png">
                        <div class="col-lg-12">
                            <h2 class="display-2 text-red">Rail Yard Automation System
                            </h2>
                            <h5 class="text-gray mt-5">Flexible Platforms for<br>
                            Unique Yard Solutions</h5>
                            <div class="btn-wrapper mt-5">
                                <router-link to="/flexyard" class="btn btn-darkred btn-lg">
                                    Go TO
                                </router-link>
                            </div>
                        </div>
                    </b-carousel-slide>
                    <b-carousel-slide img-src="img/carousel/p2.png">
                        <div class="col-lg-12">
                            <h2 class="display-2 text-red">Rail Yard Automation System
                            </h2>
                            <h5 class="text-white mt-5">
                                Receive Inbounds Faster.<br>
                                Sort Cars Smarter.<br>
                                Depart Trains Ahead of Schedule.</h5>
                            <div class="btn-wrapper mt-5">
                                <router-link to="/flexyard" class="btn btn-darkred btn-lg">
                                    Go TO
                                </router-link>
                            </div>
                        </div>
                    </b-carousel-slide>
                    <b-carousel-slide img-src="img/carousel/p3.png">
                        <div class="col-lg-12" style="margin-top:-8%;text-align:right;">
                            <h2 class="display-2 text-red">Rail Yard Automation System
                            </h2>
                            <h5 class="text-gray mt-5">
                                Increase Throughput,<br>
                                Capacity,<br>
                                and Velocity.<br>
                                <br>
                                Reduce Down Time,<br>
                                Dwell Time,<br>
                                and Operational Errors.</h5>
                            <div class="btn-wrapper mt-5">
                                <router-link to="/flexyard" class="btn btn-darkred btn-lg">
                                    Go TO
                                </router-link>
                            </div>
                        </div>
                    </b-carousel-slide>
                    <b-carousel-slide img-src="img/carousel/p4.png">
                        <div class="col-lg-12" style="margin-top:-8%;text-align:right;">
                            <h2 class="display-2 text-red">Rail Yard Automation System
                            </h2>
                            <h5 class="text-white mt-5">
                                Reduce Down Time and<br>
                                Plan Maintenance with<br>
                                Intelligent Technologies for<br>
                                Harsh Environments.<br>
                                <br>
                                Transparent Implementation,<br>
                                Uninterrupted Operations</h5>
                            <div class="btn-wrapper mt-5">
                                <router-link to="/flexyard" class="btn btn-darkred btn-lg">
                                    Go TO
                                </router-link>
                            </div>
                        </div>
                    </b-carousel-slide>
                </b-carousel>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
.section-first {
    padding-top: 5.5rem!important;
    padding-bottom: 0!important;
    background: #a80000;
}
</style>
